import React, { useState, useEffect } from 'react';
import '../../VendorStyles/Declined.css';
import axiosVendorInstance from '../../axiosVendorInstance';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import Loader from '../../Components/Loader/Loader';
import CloseIcon from '../../assets/svg/closeIcon';

function Declined() {

    const [totalPages, setTotalPages] = useState(1);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [orders, setOrders] = useState([]);
    const [vendorID, setVendorID] = useState();
    const [totalPrice, setTotalPrice] = useState();
    const [items,setItems] = useState([]);
    const pageSize = 10;

    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const fetchVendorID = async () => {
        try {
            setLoading(true);
            const vendorResponse = await axiosVendorInstance.get('/vendors/account');
            const fetchedVendorID = vendorResponse?.data?.getVendorInfo[0]?.ID;
    
            if (fetchedVendorID) {
                setVendorID(fetchedVendorID);
            }
            setLoading(false);
        } catch (error) {
            console.error('Error fetching vendor ID:', error);
            setLoading(false);
        }
    };
    

    const fetchNewOrders = async () => {
        if (!vendorID) return;
        setLoading(true);

        try {
            const response = await axiosVendorInstance.get(
                `/Order/vendor/${vendorID}?pageSize=${pageSize}&pageNumber=${page}&statusId=3`, {skipAuth:true}
            );
            const incomingData = response?.data?.allOrdersDetails || [];

            if (incomingData.length === 0 && page > 1) {
                setPage(page - 1);
            } else {
                setOrders(incomingData);
                setTotalPages(response?.data?.totalPages || 1);
            }

            setLoading(false);
        } catch (error) {
            console.error(error.message);
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!vendorID) {
            fetchVendorID();
        }
    }, [vendorID]);

    useEffect(() => {
        if (vendorID) {
            fetchNewOrders();
        }
    }, [page, vendorID]);

    const handleOrderClick = (id) => {
        const selected = orders.filter((o) => o.ID === id);
        axiosVendorInstance
            .get(`/Order/user/orderinvoice/${id}`)
            .then((response) => {
                const selectedOrderDetails = response?.data?.invoice[0]['0']?.Invoice_Details?.Order_Details;
                setTotalPrice(response?.data?.invoice[0]['0']?.Invoice_Details?.Total_Price);
                setItems(selectedOrderDetails);
                setSelectedOrder(selected);
                setShowPopup(true);
            })
            .catch((error) => console.error('Error fetching customer data:', error));
    };

    return (
        <div className="delivered-main">
            {loading ? (
                <Loader/>
            ) : (
                <div>
                    {orders && orders.length > 0 ? (
                        orders.map((order) => {
                            const createdAt = new Date(order.Created_at);
                            const time = createdAt.toLocaleTimeString('en-US', {
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: true,
                            });
                            const date = `${createdAt.getDate()} ${createdAt.toLocaleString(
                                'en-US',
                                { month: 'short' }
                            )}`;
                          

                            return (
                                <div
                                    key={order.ID}
                                    className="delivered-single-order"
                                    onClick={() => handleOrderClick(order.ID)}
                                >
                                    <div className="delivered-orderid">
                                        <p className="delivered-order-details1">
                      Order ID:
                                            <span className="delivered-order-id">{order.ID}</span>
                                        </p>
                                    </div>
                                    <div>
                                        <p className="declined-reason-text">Reason:</p>
                                    </div>
                                    <div className="delivered-date-and-time">
                                        <p className="delivered-order-details2">{time}</p>
                                        <p className="delivered-order-details3">{date}</p>
                                    </div>
                                  
                                </div>
                            );
                        })
                    ) : orders.length === 0 && (
                        <div className="no-data-message">No data</div>
                    )}

                    {showPopup && (
                        <div className="delivered-popup-container">
                            <div className="delivered-popup">
                                {selectedOrder.map((order, index) => {
                                    const createdAt = new Date(order.Created_at);
                                    const time = createdAt.toLocaleTimeString('en-US', {
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        hour12: true,
                                    });
                                    const date = `${createdAt.getDate()} ${createdAt.toLocaleString(
                                        'en-US',
                                        { month: 'short' }
                                    )}`;
                                    const status =
                    order.Status_id === 3 ? 'Declined' : 'Delivered';
                                    return (
                                        <div
                                            key={index}
                                            className="delivered-orders-single-container"
                                        >
                                            <div className="delivered-orders-single-top1">
                                                <p className="delivered-orders-order-id-text">
                          Order ID:{' '}
                                                    <span className="delivered-orders-order-id">
                                                        {order.ID}
                                                    </span>
                                                </p>
                                                <div className="delivered-orders-order-date-and-time">
                                                    <p className="delivered-orders-order-time">{time}</p>
                                                    <p className="delivered-orders-order-date">{date}</p>
                                                </div>
                                                <CloseIcon
                                                    size={30}
                                                    color='black'
                                                    onClick={() => setShowPopup(false)}
                                                    className='close-icon'
                                                />
                                            </div>
                                            <div className="delivered-orders-dotted-line"></div>
                                            <div className="delivered-order-items-container">
                                                {items.map((item, index) => (
                                                    <div key={index} className='delivered-order-item-row'>
                                                        <p className="delivered-order-items">
                                                            {item.Quantity} X {item.Menu_Item_Name}
                                                        </p>
                                                        <p className='delivered-order-items-price'>
                                                            ${item.Menu_Item_Price * item.Quantity}
                                                        </p>
                                                    </div>
                                                ))}
                                            </div>
                                            <div className="delivered-orders-dotted-line"></div>
                                            <div className="delivered-order-bottom-container">
                                                <div className="delivered-order-bottom-container1">
                                                    <div className="delivered-orders-declined-circle">
                                                        <svg
                                                            width="7"
                                                            height="7"
                                                            viewBox="0 0 7 7"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                                d="M2.8587 3.50005L0.133037 0.774253C-0.0443449 0.596951 -0.0443449 0.310278 0.133037 0.132976C0.310335 -0.0443255 0.597001 -0.0443255 0.7743 0.132976L3.50004 2.85878L6.2257 0.132976C6.40308 -0.0443255 6.68967 -0.0443255 6.86696 0.132976C7.04435 0.310278 7.04435 0.596951 6.86696 0.774253L4.1413 3.50005L6.86696 6.22585C7.04435 6.40315 7.04435 6.68983 6.86696 6.86713C6.77861 6.95557 6.66243 7 6.54633 7C6.43024 7 6.31414 6.95557 6.2257 6.86713L3.50004 4.14133L0.7743 6.86713C0.685858 6.95557 0.569763 7 0.453668 7C0.337573 7 0.221478 6.95557 0.133037 6.86713C-0.0443449 6.68983 -0.0443449 6.40315 0.133037 6.22585L2.8587 3.50005Z"
                                                                fill="white"
                                                            />
                                                        </svg>
                                                    </div>

                                                    <p className="delivered-order-status-text">
                                                        {status}
                                                    </p>
                                                </div>
                                                <p className="delivered-order-price-text">$ {totalPrice}</p>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                            <div className="new-orders-blur-background"></div>
                        </div>
                    )}

                    {orders.length > 0 && totalPages > 1 && (
                        <div className="pagination-container">
                            <Stack spacing={2}>
                                <Pagination
                                    sx={{
                                        '& .MuiPagination-ul': {
                                            color: '#333',
                                            padding: 1,
                                            borderRadius: 2,
                                            display: 'flex',
                                            justifyContent: 'center',
                                            listStyleType: 'none',
                                        },
                                    }}
                                    count={totalPages}
                                    page={page}
                                    onChange={handlePageChange}
                                    showFirstButton
                                    showLastButton
                                />
                            </Stack>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

export default Declined;